import { Languages } from './translation';

const serviceName: 'bubblechat' | 'tingle' = import.meta.env.VITE_APP_SERVICE_NAME || 'bubblechat'; // 기본값: bubblechat

export type UnrecognizedType = 'UNRECOGNIZED';

export const POLICY_PAGE_LIST = [
  { key: 'general.terms_of_service', th_label: 'ข้อกำหนดการให้บริการ', eng_value: 'terms', kor_value: '이용약관' },
  {
    key: 'general.privacy_policy',
    th_label: 'นโยบายความเป็นส่วนตัว',
    eng_value: 'privacy',
    kor_value: '개인정보처리방침',
  },
  { key: 'general.operation_policy', th_label: 'นโยบายการดำเนินงาน', eng_value: 'regulation', kor_value: '운영정책' },
  {
    key: 'general.juvenile_protection_policy',
    th_label: 'นโยบายความปลอดภัยของเด็กและเยาวชน',
    eng_value: 'youth',
    kor_value: '청소년보호정책',
  },
];

export const BUBBLETAP_TEL = '+82 02-2039-7572 ';
export const REGISTRATION_NUMBER = '248-88-02802';
export const MAIL_ORDER_SALES_REGISTRATION_NUMBER = '제 2022-서울강남-05661호';

const SUPPORT_EMAIL = {
  bubblechat: { default: 'support@bubbletap.com' },
  tingle: {
    default: 'support@tingle.chat',
    zh: 'tw.support@tingle.chat',
  },
};

export const supportEmail = (language?: Languages) => {
  const service = SUPPORT_EMAIL[serviceName];

  return language && service[language as keyof typeof service]
    ? service[language as keyof typeof service]
    : service.default;
};
